export default __webpack_public_path__ + "static/media/landing-hero.0cc19fe9.png";